import { Center as ChakraCenter } from "@chakra-ui/react";

export const Center = ChakraCenter;
